import { Component, Input } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'

@Component({
  selector: 'jml-lib-group-cell',
  templateUrl: './group-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class GroupCellComponent extends InlineEditCellDirective {
  @Input() relation: string
  @Input() header: string

  displayGroupRelationDialog = false

  cancel() {
    this.completeCellEdit.emit({ data: this.rowData, field: this.fieldName })
  }

  triggerEdit() {
    this.displayGroupRelationDialog = true
  }
}
